import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV161({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.6.1" date="18th September 2025" title="We're excited to incorporate your thoughts and ideas!">
      <p className="text-gray-300 mb-4">One aspect we overlooked while developing the app was 'low power mode.' It disrupts our notification platform. We addressed the issue and released a fix in under a week, demonstrating our agility in engaging with the Poppy Poker community.</p>
      <p className="text-gray-300 mb-4">Another great feature in this release is the "game audit log for admin users." You can now view a complete chronological audit of events. Press the 'Add one minute' button, and all changes are logged, making it easy to track any accidental clock or game adjustments.</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        {createClickableListItem('Low power mode detection - no more false/missed alerts', '/v1.6.1/lowPowerMode1.jpg')}
        {createClickableListItem('Game audit log for admin users', '/v1.6.1/gameLog.jpg')}
        {createClickableListItem('Game connection stats for admin users, available from game screen', '/v1.6.1/connectionStats.jpg')}
        <li>• Backend retry mechanism if client requests fail</li>
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.6.1/lowPowerMode1.jpg', 'Low power mode detection - no more false/missed alerts feature preview')}
          {createThumbnail('/v1.6.1/lowPowerMode2.jpg', 'Low power mode detection - no more false/missed alerts feature preview')}
          {createThumbnail('/v1.6.1/gameLog.jpg', 'Game audit log for admin users feature preview')}
          {createThumbnail('/v1.6.1/connectionStats.jpg', 'Game connection stats for admin users, available from game screen feature preview')}
        </div>
      </div>
      <p className="text-purple-400 font-medium">Thank you for your feedback and helping us improve Poppy Poker!</p>
    </ReleaseCard>
  );
}
